export default "__VITE_ASSET__5709bce4__"